import React, { useState, useEffect, useRef } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useLazyQuery } from "@apollo/client";
import ReportSurveyFilters from "../../components/ReportSurveyBlock/ReportSurveyFilters/ReportSurveyFilters";
import { getStateLoginComplete } from "../LayoutHome/stateLogin";
import {
  ContainerReport,
  TitleReport,
  ContainerHead,
  ContentSurveyRating,
  BtnDownloadSurveyRating,
  ContentDownloadFile,
  TextDownloadFile,
} from "./ReportSurveyContainer.styled";
import {
  COUNTRIES_BY_CLIENT,
  SITES_BY_CLIENT,
  GRAPH_BY_SURVEY,
  DOWNLOAD_ALL_ANSWER_SURVEY,
  DOWNLOAD_ALL_OPEN_TEXT_ANSWER_BY_QUESTION,
  DOWNLOAD_FEEDBACKS_BYIDSURVEY,
  AVERAGE_FEEDBACKS_BYIDSURVEY,
  ALL_LOBS_COUNTRY,
} from "../../GraphQL/Queries";
import ExportExcelFile from "../../components/ReportSurveyBlock/ExportExcelFile/ExportExcelFile";
import GraphicsResume from "../../components/Graphics/GraphicsResume/GraphicsResume";
import UserResume from "../../components/Graphics/UserResume/UserResume";
import ModalLoader from "../../components/ModalLoader/ModalLoader";
import { NotificationManager } from "react-notifications";
import ImageRatingGraph from "../../components/Graphics/ImageRatingGraph/ImageRatingGraph";
import staron from "../../assets/staron.png";
import staroff from "../../assets/staroff.png";
import BackButtonComponent from "../../components/BackButtonComponent/BackButtonComponent";
import ModalDownloadAnswersSurvey from "../../components/ModalDownloadAnswersSurvey/ModalDownloadAnswersSurvey";

const ReportSurveyContainer = () => {
  const location = useLocation();
  const [name, setSurveyName] = useState(location.state.surveyName);
  const [id, setId] = useState(location.state.idSurvey);
  const [UserComplete] = useState(getStateLoginComplete());
  const [countries, setCountries] = useState([]);
  const [lob, setLobs] = useState();
  const [cities, setCities] = useState();
  const [sites, setSites] = useState();
  const [dataExport, setDataExport] = useState();
  const [dataQuestions, setDataQuestions] = useState();
  const [nameFile, setNameFile] = useState();
  const [dataFilter, changeDataFilter] = useState();
  const [ratingGraph, setratingGraph] = useState();
  const history = useHistory();
  const rCities = useRef();
  const rSites = useRef();

  const [showModalDownloadAnswers, setShowModalDownloadAnswers] =
    useState(false);

  const [selectedCheckbox, setSelectedCheckbox] = useState({
    surveyName: true,
    user: true,
    client: true,
    country: true,
    city: true,
    role: true,
    lob: true,
    tpid: true,
    username: true,
    answerDate: true,
    activationDate: true,
    userStatus: true,
  });

  const [runQueryCountry, { loading: loadingCountries }] = useLazyQuery(
    COUNTRIES_BY_CLIENT,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        let resultOfCountries = data.countryLocationList.map((element) => {
          return {
            ...element,
            value: element?.countryId,
            label: element?.countryName,
          };
        });
        setCountries(resultOfCountries);
      },
    }
  );

  const [runQueryLobsByCountry, { loading: loadingLobsByCountry }] =
    useLazyQuery(ALL_LOBS_COUNTRY, {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        let resultOfLobs = data.lobsListByCountry.map((element) => {
          return {
            value: element?.lobId,
            label: element?.lobName,
          };
        });
        setLobs(resultOfLobs);
      },
    });

  const [runQueryGraphFeeback] = useLazyQuery(AVERAGE_FEEDBACKS_BYIDSURVEY, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let dto = {
        title: "Survey Rating",
        subtitle: `${data.downloadFeedbacksByIdSurvey.outputData.totalUsers} Users`,
        labels: ["Av"],
        data: [data.downloadFeedbacksByIdSurvey.outputData.average],
        limit: 5,
        symbol: `image://${staron}`,
        symbolLimit: `image://${staroff}`,
        strictLimit: true,
        width: "350px",
        height: "150px",
        formaterLegent: function (params) { },
      };
      setratingGraph(dto);
    },
  });
  const [runQueryDownLoadFeeback] = useLazyQuery(
    DOWNLOAD_FEEDBACKS_BYIDSURVEY,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        setDataExport(data.downloadFeedbacksByIdSurvey.outputData.download);
      },
    }
  );

  const [runQuerySites, { loading: loadingSites }] = useLazyQuery(
    SITES_BY_CLIENT,
    {
      fetchPolicy: "cache-and-network",
      onCompleted: (data) => {
        let resultOfSites = data.sitesByCities.map((element) => {
          return {
            value: element?.siteId,
            label: element?.siteName,
          };
        });
        setSites(resultOfSites);
      },
    }
  );

  const [runQueryGraphBySurvey, { loading: loadingGraphSurvey }] = useLazyQuery(
    GRAPH_BY_SURVEY,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        if (data?.graphsBySurvey2?.length > 0) {
          let questions = data.graphsBySurvey2.map((e) => {
            return e.value;
          });
          setDataQuestions(questions);
        }
      },
    }
  );

  const [
    runQueryDownloadAllAnswersSurvey,
    { loading: loadingDownloadAllAnswer },
  ] = useLazyQuery(DOWNLOAD_ALL_ANSWER_SURVEY, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      if (!data.downloadAllAnswersSurvey.withError) {
        let resultOfAnswersSurvey =
          data.downloadAllAnswersSurvey.outputData.answers.map((element) => {
            let result = {};
            for (const property in element) {
              if (property === "answer") {
                continue;
              }
              if (
                !(element[property] === null || element[property] === undefined)
              ) {
                result[property] = element[property];
              }
            }
            const { answer } = element;
            let count = Object.values(selectedCheckbox).filter((x) => x).length;
            answer.forEach((item) => {
              result[data.downloadAllAnswersSurvey.outputData.headers[count]] =
                item;
              count++;
            });
            return { ...result };
          });
        setDataExport(resultOfAnswersSurvey);
      }
    },
  });

  const [
    runQueryDownloadAllOpenTextAnswersByQuestion,
    { loading: loadingDownloadAnswerOpenText },
  ] = useLazyQuery(DOWNLOAD_ALL_OPEN_TEXT_ANSWER_BY_QUESTION, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      if (!data.downloadAllOpenTextAnswersByQuestion.withError) {
        let resultOfOpenTextAnswers =
          data.downloadAllOpenTextAnswersByQuestion.outputData.answers.map(
            (element) => {
              let result = {};
              if (element.surveyName) result.surveyName = element.surveyName;

              if (element.ccmsUser) result.ccmsUser = element.ccmsUser;

              if (element.clientName) result.clientName = element.clientName;

              if (element.countryName) result.countryName = element.countryName;

              if (element.cityName) result.cityName = element.cityName;

              result[
                data?.downloadAllOpenTextAnswersByQuestion?.outputData?.headers[
                data?.downloadAllOpenTextAnswersByQuestion?.outputData
                  ?.headers?.length - 1
                ]
              ] = element?.answer;
              return result;
            }
          );
        setDataExport(resultOfOpenTextAnswers);
      }
    },
  });

  const getCityForCountry = (id) => {
    let selectedCountry = countries.filter((e) => e.countryId === parseInt(id));
    if (selectedCountry?.length > 0) {
      let citiesArr = selectedCountry[0].cities.map((e) => {
        return {
          ...e,
          value: e.cityId,
          label: e.cityName,
        };
      });
      setCities(citiesArr);
    } else {
      setCities([]);
    }
  };

  let handleChangeSelectCountry = (item) => {
    setCities([]);
    setSites([]);
    if (item?.value) {
      getCityForCountry(item.value);
      rCities.current.clearValue();
      rSites.current.clearValue();
      runQueryLobsByCountry({
        variables: { countryId: item?.value, searchBy: "" },
        context: { clientName: "LinkUsers" },
      });
    }
  };

  let handleChangeSelectCity = (item) => {
    setSites([]);
    if (item?.value) {
      runQuerySites({
        variables: { clientId: UserComplete.clientId, cityId: item?.value },
        context: { clientName: "LinkUsers" },
      });
    }
  };

  let exportAsExcelFile = () => {
    setNameFile("Survey_" + id);

    runQueryDownloadAllAnswersSurvey({
      variables: {
        surveyId: id,
        filterByLocation: isFilterByLocation(dataFilter),
        initielDate: dataFilter?.inicialDate,
        finalDate: dataFilter?.finalDate,
        lobs: dataFilter?.lobs,
        site: dataFilter?.site,
        city: dataFilter?.city,
        state: dataFilter?.state,
        country: dataFilter?.country,
        surveyName: name,
        surveyNameHeader: selectedCheckbox.surveyName,
        userHeader: selectedCheckbox.user,
        clientHeader: selectedCheckbox.client,
        countryHeader: selectedCheckbox.country,
        cityHeader: selectedCheckbox.city,
        lobHeader: selectedCheckbox.lob,
        tpIdHeader: selectedCheckbox.tpid,
        usernameHeader: selectedCheckbox.username,
        answerDateHeader: selectedCheckbox.answerDate,
        activationDateHeader: selectedCheckbox.activationDate,
        userStatusHeader: selectedCheckbox.userStatus,
        roleHeader: selectedCheckbox.role,
      },
    })
      .then((res) => {
        if (res) {
          setShowModalDownloadAnswers(false);
        }
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  let downloadOpenTextQuestion = (idQuestionBanck, questionName) => {
    setNameFile("OpenTextAnswer_" + questionName);

    runQueryDownloadAllOpenTextAnswersByQuestion({
      variables: {
        questionBankId: idQuestionBanck,
        filterByLocation: isFilterByLocation(dataFilter),
        initielDate: dataFilter?.inicialDate,
        finalDate: dataFilter?.finalDate,
        lobs: dataFilter?.lobs,
        site: dataFilter?.site,
        city: dataFilter?.city,
        state: dataFilter?.state,
        country: dataFilter?.country,
        surveyName: name,
      },
    });
  };

  let isFilterByLocation = (filter) => {
    return (
      filter.lobs.length > 0 ||
      filter.country !== undefined ||
      filter.state !== undefined ||
      filter.city !== undefined ||
      filter.site !== undefined
    );
  };

  let idDateFilterValid = () => {
    return (
      (dataFilter?.inicialDate !== null && dataFilter?.finalDate !== null) ||
      (dataFilter?.inicialDate === null && dataFilter?.finalDate === null)
    );
  };

  let getGraphBySurvey = () => {
    if (idDateFilterValid()) {
      setDataQuestions();
      runQueryGraphBySurvey({
        variables: {
          surveyId: id,
          filterByLocation: isFilterByLocation(dataFilter),
          initielDate: dataFilter?.inicialDate,
          finalDate: dataFilter?.finalDate,
          lobs: dataFilter?.lobs,
          site: dataFilter?.site,
          city: dataFilter?.city,
          state: dataFilter?.state,
          country: dataFilter?.country,
        },
      });
    } else {
      NotificationManager.warning("Date filter with invalid range", "", 5000);
    }
  };

  let cleanFilters = () => {
    setDataQuestions();
    setCities([]);
    setSites([]);
  };

  let goToDetailReportsList = () => {
    history.push(`/DetailReports`);
  };

  let closeModal = () => {
    setShowModalDownloadAnswers(false);
  };

  useEffect(() => {
    runQueryCountry({
      variables: { clientId: UserComplete.clientId },
      context: { clientName: "LinkUsers" },
    });
  }, [UserComplete]);

  useEffect(() => {
    if (location.state.idSurvey && location.state.surveyName) {
      setSurveyName(location.state.surveyName);
      setId(location.state.idSurvey);
    }
  }, [location.state.idSurvey, location.state.surveyName]);

  useEffect(() => {
    if (id && name) {
      runQueryGraphFeeback({
        variables: { surveyId: id, surveyName: name },
      }).catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
    }
  }, [id, name]);

  const modalDownloadAnswersSurvey = showModalDownloadAnswers && (
    <ModalDownloadAnswersSurvey
      closeModal={closeModal}
      handleDownloadExcel={exportAsExcelFile}
      labelOfButton={"Download"}
      selectedCheckbox={selectedCheckbox}
      setSelectedCheckbox={setSelectedCheckbox}
    />
  );

  return (
    <ContainerReport>
      {(loadingCountries ||
        loadingLobsByCountry ||
        loadingSites ||
        loadingGraphSurvey ||
        loadingDownloadAllAnswer ||
        loadingDownloadAnswerOpenText) && <ModalLoader></ModalLoader>}
      {(UserComplete.userName === "tamayoortega.6" ||
        UserComplete.userName === "gopal.84" ||
        UserComplete.userName === "castrosarmiento.7" ||
        UserComplete.userName === "bedoyamunera.6" ||
        UserComplete.userName === "beltrancastaneda.6" ||
        UserComplete.userName === "gulati.275" ||
        UserComplete.userName === "sharanya.19" ||
        UserComplete.userName === "kunarapu.7" ||
        UserComplete.userName === "reddy.892") && (
          <ContainerHead>
            <BackButtonComponent
              backtitle={"Back to survey reports"}
              locationtitle={name}
              goToBackPage={goToDetailReportsList}
              identity={"surveyReports"}
            />
            <TitleReport>{name}</TitleReport>
            <ContentDownloadFile
              className="mt-2"
              onClick={() => setShowModalDownloadAnswers(true)}
            >
              <ExportExcelFile
                data={dataExport}
                nameFile={nameFile}
                withIcon={true}
              ></ExportExcelFile>
              <TextDownloadFile style={{ marginRight: "2em" }}>
                Download
              </TextDownloadFile>
            </ContentDownloadFile>
          </ContainerHead>
        )}
      {!(
        UserComplete.userName === "tamayoortega.6" ||
        UserComplete.userName === "perezorduz.5" ||
        UserComplete.userName === "rao.479" ||
        UserComplete.userName === "guampepirazan.5" ||
        UserComplete.userName === "gopal.84" ||
        UserComplete.userName === "castrosarmiento.7" ||
        UserComplete.userName === "bedoyamunera.6" ||
        UserComplete.userName === "beltrancastaneda.6" ||
        UserComplete.userName === "gulati.275"
      ) && (
          <ExportExcelFile
            data={dataExport}
            nameFile={nameFile}
            withIcon={false}
          ></ExportExcelFile>
        )}

      <ReportSurveyFilters
        countries={countries}
        lob={lob}
        cities={cities}
        sites={sites}
        handleChangeSelectCountry={handleChangeSelectCountry}
        handleChangeSelectCity={handleChangeSelectCity}
        handleSetFilters={getGraphBySurvey}
        handleChangeDataFilter={changeDataFilter}
        handleCleanFilters={cleanFilters}
        rSites={rSites}
        rCities={rCities}
      ></ReportSurveyFilters>

      <UserResume idSurvey={id}></UserResume>
      <ContentSurveyRating>
        {ratingGraph && (
          <ImageRatingGraph option={ratingGraph}></ImageRatingGraph>
        )}
        {ratingGraph && ratingGraph.data[0] > 0 && (
          <div style={{ textAlign: "center" }} hidden={true}>
            <BtnDownloadSurveyRating
              onClick={() => {
                setNameFile("Feedback_" + name);
                runQueryDownLoadFeeback({
                  variables: { surveyId: id, surveyName: name },
                });
              }}
            >
              Download details
            </BtnDownloadSurveyRating>
          </div>
        )}
      </ContentSurveyRating>
      {dataQuestions && (
        <GraphicsResume
          dataQuestions={dataQuestions}
          fnDownLoad={downloadOpenTextQuestion}
        ></GraphicsResume>
      )}
      {modalDownloadAnswersSurvey}
    </ContainerReport>
  );
};
export default ReportSurveyContainer;
